import { Component, EventEmitter, Output, OnInit, OnDestroy, Input, OnChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom, Subscription } from 'rxjs';

import { GifService } from '../../services/gif/gif.service';
import { ThemeService } from '../../services/theme/theme.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { GeneralToastComponent } from '../../toasts/general-toast/general-toast.component';

@Component({
  selector: 'sc-gif-selector',
  templateUrl: './gif-selector.component.html',
  styleUrls: ['./gif-selector.component.scss'],
})
export class GifSelectorComponent implements OnInit, OnDestroy, OnChanges {
  @Output() selected = new EventEmitter<any>();
  @Output() back = new EventEmitter<any>();
  @Input() gifSearchQuery: string;
  query: string;
  gifs: Array<any> = [];
  subs: Array<Subscription> = [];

  theme$ = this.themeService.theme$;

  constructor(
    private toastrService: ToastrService,
    private gifService: GifService,
    private themeService: ThemeService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.setupGifs();
  }

  ngOnChanges(changes) {
    if (changes.gifSearchQuery?.currentValue) {
      this.query = changes.gifSearchQuery.currentValue;
      this.search();
    }
  }

  goBack() {
    this.back.emit();
  }

  async select(gif: any) {
    this.selected.emit(gif);
    await this.analyticsService.track('selected gif', { gif });
  }

  async search() {
    if (!this.query) {
      this.toastrService.info(null, `Type a word or phrase to search for a Gif`, {
        progressBar: true,
        progressAnimation: 'decreasing',
        closeButton: true,
        tapToDismiss: false,
        timeOut: 5 * 1000,
        toastComponent: GeneralToastComponent,
      });

      return;
    }

    const response: any = await firstValueFrom(this.gifService.search(this.query, 6));
    if (!response) {
      return;
    }
    if (!response.data) {
      return;
    }

    this.gifs = response.data;

    await this.analyticsService.track('searched for gif', { query: this.query });
  }

  setupGifs() {
    const sub = this.gifService.getTrending(6).subscribe((response: any) => {
      if (!response) {
        return;
      }
      if (!response.data) {
        return;
      }

      if (this.gifs.length === 0) {
        this.gifs = response.data.map((gif: any) => {
          return gif;
        });
      }
    });

    this.subs.push(sub);
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
